<!--
 * @Author: taosong
 * @Date: 2021-03-03 15:24:55
 * @LastEditors: taosong
 * @LastEditTime: 2021-03-29 09:56:24
 * @Description: taosongs
-->
<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
import { setTheme } from "./utils/theme.js";
import { useStore } from "vuex";
import { computed, watchEffect } from "vue";
export default {
  setup() {
    const store = useStore();
    //在页面加载时读取localstorage里的状态信息
    if (localStorage.getItem("store")) {
      store.replaceState(
        Object.assign(
          {},
          store.state,
          JSON.parse(localStorage.getItem("store"))
        )
      );
    }
    const isBeike = computed(() => {
      return store.getters.isBeike;
    });
    watchEffect(() => {
      if (isBeike.value) {
        setTheme(isBeike ? "blue" : "red");
      }
    });
    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener(
      "beforeunload",
      () => {
        localStorage.setItem("store", JSON.stringify(store.state));
      },
      false
    );
  },
};
</script>
<style>
.van-toast.large-toast {
  width: 100px;
}
.van-toast.large-toast-mobile {
  width: 260px;
}
</style>
